import { Icon } from '@aibees/shared/components';
import { Box, Stack, Typography } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useWhiteLabelContext } from '@aibees/elephant/feature/white-label/context';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProfileDashboardPreviewProps as Props } from './types';
import { items } from './config';

export const ProfileDashboardPreview = memo(({ className }: Props) => {
  const { primaryColor } = useWhiteLabelContext();

  const color = !primaryColor.error ? primaryColor.value : undefined;

  return (
    <Styled.Wrapper
      className={classnames('ProfileDashboardPreview', className)}
      title="Profile Dashboard"
    >
      <Box sx={SX.container(color)}>
        <Stack sx={SX.header} gap={0.5}>
          <Typography sx={SX.headerTitle}>Mehran Bahrami</Typography>
          <Typography sx={SX.headerDes}>Admin | Mehran@ai-bees.io</Typography>
        </Stack>
        <Stack sx={SX.credit}>
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={SX.creditCount}
          >
            <Typography sx={SX.creditTitle}>Credit</Typography>
            <Stack direction="row">
              <Typography sx={SX.creditTotal}>4,352</Typography>
              <Typography sx={SX.creditUsage}>/ 100,000</Typography>
            </Stack>
          </Stack>
          <Box sx={SX.progressWrapper}>
            <Box sx={SX.progress(color)} />
          </Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={SX.creditTime}
          >
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Typography sx={SX.creditTimeTitle(color)}>22</Typography>
              <Typography sx={SX.creditTimeTitle('black')}>Days</Typography>
              <Icon name="info" sxx={SX.creditTimeIcon} size={12} />
            </Stack>
            <Typography sx={SX.creditTimeDes(color)}>View Details</Typography>
          </Stack>
        </Stack>
        <Stack>
          <Typography sx={SX.itemTitle}>Profile</Typography>
          <Stack>
            {items.slice(0, 4).map((i, index) => (
              <Stack
                key={i.title}
                direction="row"
                alignItems="center"
                gap={0.5}
                sx={SX.item({ color, isSelected: false, isHover: index === 1 })}
              >
                <Icon
                  name={i.icon}
                  size={20}
                  sxx={SX.itemIcon({
                    color,
                    isSelected: false,
                    isHover: false,
                  })}
                />{' '}
                {i.title}
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack>
          <Typography sx={SX.itemTitle}>Records</Typography>
          <Stack>
            {items.slice(4, 7).map((i, index) => (
              <Stack
                key={i.title}
                direction="row"
                alignItems="center"
                gap={0.5}
                sx={SX.item({ color, isSelected: index === 0, isHover: false })}
              >
                <Icon
                  name={i.icon}
                  size={20}
                  sxx={SX.itemIcon({
                    color,
                    isSelected: index === 0,
                    isHover: false,
                  })}
                />{' '}
                {i.title}
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack>
          <Typography sx={SX.itemTitle}>System Activity</Typography>
          <Stack>
            {items.slice(7, 8).map((i) => (
              <Stack
                key={i.title}
                direction="row"
                alignItems="center"
                gap={0.5}
                sx={SX.item({ color, isSelected: false, isHover: false })}
              >
                <Icon
                  name={i.icon}
                  size={20}
                  sxx={SX.itemIcon({
                    color,
                    isSelected: false,
                    isHover: false,
                  })}
                />{' '}
                {i.title}
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Box>
    </Styled.Wrapper>
  );
});

ProfileDashboardPreview.displayName = 'ProfileDashboardPreview';
